<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title" ngbAutofocus>{{ "Template.MainComponent.subHeader_ssoRegistration" | translate }}</h4>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col">
        <p>
          {{ "Template.SsoSignupModalComponent.text_explanation1" | translate }}
        </p>
        <p [innerHTML]="'Template.SsoSignupModalComponent.text_explanation2' | translate"></p>
      </div>
      <div class="col-12 col-md-3 col-lg-2">
        <img src="assets/images/sso/sso-badge-sm.png" alt="SSO Logo" class="img-fluid" />
      </div>
    </div>
    <p class="mb-0">
      {{ "Template.SsoSignupModalComponent.text_email1" | translate }}
      <strong>{{ currentUser?.email }} </strong>
      @if (ssoUserExists) {
        <span>{{ "Template.SsoSignupModalComponent.text_email2_link" | translate }}</span>
      }
      @if (!ssoUserExists) {
        <span>{{ "Template.SsoSignupModalComponent.text_email2_register" | translate }}</span>
      }
    </p>
  </div>

  <div class="modal-footer">
    @if (!loading && !ssoUserExists) {
      <button type="button" class="btn btn-primary" (click)="redirectToRegister()">
        <fa-icon icon="user-plus" class="me-2"></fa-icon>
        {{ "Template.SsoSignupFormComponent.btn_signupSso" | translate }}
        @if (registeringSso) {
          <fa-icon icon="spinner" animation="spin" class="ms-2"></fa-icon>
        }
      </button>
    }

    @if (!loading && ssoUserExists) {
      <button type="button" class="btn btn-primary" (click)="redirectToSignInAndLink()">
        <fa-icon icon="link" class="me-2"></fa-icon>
        {{ "Template.SsoSettingsComponent.btn_linkAccount" | translate }}
        @if (linkingSso) {
          <fa-icon icon="spinner" animation="spin" class="ms-2"></fa-icon>
        }
      </button>
    }

    <span>
      @if (loading) {
        <fa-icon icon="spinner" animation="spin" class="ms-2" size="2x"></fa-icon>
      }
    </span>
  </div>
</div>
